import { request } from '../request';

export const workspaceApi = {
  listFiles: () =>
    request('/agent/files').then((files) =>
      files.map((file) => ({
        ...file,
        updated_at: new Date(file.modified_time).getTime()
      }))
    ),

  loadFile: (fileName) => request(`/agent/files/${encodeURIComponent(fileName)}`),

  saveFile: (fileName, content) =>
    request(`/agent/files/${encodeURIComponent(fileName)}`, {
      method: 'PUT',
      body: JSON.stringify({ content })
    }),

  downloadWorkspace: async () => {
    const response = await request('/workspace/download', {
      method: 'GET',
      rawResponse: true
    });

    if (!response.ok) {
      throw new Error(`Workspace download failed: ${response.status} ${response.statusText}`);
    }

    return await response.blob();
  },

  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await request('/workspace/upload', {
      method: 'POST',
      body: formData
    });

    return response;
  },

  listDailyMemory: () =>
    request('/agent/memory').then((files) =>
      files.map((file) => {
        const date = file.filename.replace('.md', '');
        return {
          ...file,
          date,
          updated_at: new Date(file.modified_time).getTime()
        };
      })
    ),

  loadDailyMemory: (date) => request(`/agent/memory/${encodeURIComponent(date)}.md`),

  saveDailyMemory: (date, content) =>
    request(`/agent/memory/${encodeURIComponent(date)}.md`, {
      method: 'PUT',
      body: JSON.stringify({ content })
    })
};
